import axios from "axios";
import { saveAs } from 'file-saver';
import configData from "../../config/config.json";
import { handleBlobError, handleCallBack } from "./commonStuff";

export const ReportUserAuditKey = "auditUsersReport";

export const setSelectedReportType = (selectedReportType) => {
    return {
        type: 'SET_SELECTED_REPORT_TYPE',
        selectedReportType
    }
}

const handleReportResults = (dispatch, reportCriteria, reportType) => {
  dispatch({ type: 'UPDATE_REPORT_CRITERIA', reportCriteria, reportType }); 
};


// User Report - PDF
export const reportUser = (reportCriteria, history, callback) => async dispatch => {
  await axios.post(configData.LANDNOTIFICATION_SERVER_URL + "report/userReport", reportCriteria, {  responseType: 'blob', withCredentials: true })
    .then((response) => {
      handleReportResults(dispatch, reportCriteria, ReportUserAuditKey);
      let blob = new Blob([response.data], { type: 'application/pdf' });
      saveAs(blob, 'UserReport.pdf');
      handleCallBack(callback);
    }, (error) => {
      handleBlobError(error, history, callback);
    });
};

// User Report - Excel
export const exportUser = (reportCriteria, history, callback) => async dispatch => {
  dispatch({ type: 'LOADING', data: true }); 
  await axios.post(configData.LANDNOTIFICATION_SERVER_URL + "report/userExport", reportCriteria, {  responseType: 'arraybuffer', withCredentials: true })
    .then((response) => {
      handleReportResults(dispatch, reportCriteria, ReportUserAuditKey);
      let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'UserReportExport.xlsx');
      handleCallBack(callback); 
    }, (error) => {
      handleBlobError(error, history, callback);
    });
};